@let property = property$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Walking Farm&#174; Alerts</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  @if (alertsLoaded$ | async) {
    @let alertsList = alertsList$ | async;

    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>
          {{ property | redAddress: addressType.LineOne }}
        </ion-label>
      </ion-list-header>
      <ion-item>
        <ion-label>
          {{ property | redAddress: addressType.LineTwo }}
        </ion-label>
      </ion-item>
      @if (alertsList && alertsList.length) {
        <ion-item>
          <ion-icon slot="start" color="medium" name="calendar-number-outline"></ion-icon>
          <ion-label color="medium"> Last Farm Alert </ion-label>
          <ion-note slot="end">{{ alertLastDate$ | async | date: 'MM/dd/yyyy' | redDashIfEmpty }}</ion-note>
        </ion-item>
      } @else {
        <ion-item>
          <ion-label color="medium">There are no farm alerts for this property.</ion-label>
        </ion-item>
      }
      <ion-item
        color="primary"
        [button]="true"
        [detail]="false"
        [disabled]="!(unreadAlerts$ | async)?.length"
        (click)="markAllAlertsAsRead()"
      >
        <ion-label> Mark all alerts as read </ion-label>
        <ion-icon slot="end" name="checkmark-circle-outline"></ion-icon>
      </ion-item>
    </ion-list>
    @if (alertsList && alertsList.length) {
      <ion-list [inset]="true" class="no-last-line">
        <ion-accordion-group>
          @for (alert of alertsList$ | async; track alertsListTrackBy(i, alert); let i = $index) {
            <ion-item-divider
              ><ion-label color="medium" class="tw:h-4 tw:w-full">
                <span
                  class="tw:block tw:h-full tw:w-full tw:overflow-hidden tw:text-xs tw:text-ellipsis tw:whitespace-nowrap"
                >
                  {{ alert.date | date: 'MM/dd/yyyy' }}
                </span>
              </ion-label>
            </ion-item-divider>
            <ion-accordion value="{{ i }}">
              <ion-item slot="header" color="light" (click)="markAlertAsRead(alert)">
                <ion-icon
                  slot="start"
                  [color]="alert.isRead ? 'medium' : 'danger'"
                  name="notifications-circle-outline"
                ></ion-icon>
                <ion-label color="dark">{{ alert.displayType | titlecase }}<br /> </ion-label>
              </ion-item>
              <ion-list slot="content" lines="full">
                @for (data of alert.data; track data) {
                  @for (item of data | keyvalue; track item) {
                    <ion-item>
                      <ion-label color="medium">
                        {{ item.key }}<br />
                        <ion-note color="dark" class="tw:font-bold tw:text-wrap">
                          {{ item.value | redDashIfEmpty }}
                        </ion-note>
                      </ion-label>
                    </ion-item>
                  }
                }
              </ion-list>
            </ion-accordion>
          }
        </ion-accordion-group>
      </ion-list>
    }
  } @else {
    <ion-list [inset]="true" lines="none" class="no-last-line">
      <ion-list-header>
        <ion-label>
          <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text>
        </ion-label>
      </ion-list-header>
      <ion-item>
        <ion-label color="medium">
          <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text
        ></ion-label>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" class="no-last-line">
      <ion-accordion-group>
        @for (alert of [1, 2]; track alert; let i = $index) {
          <ion-item-divider>
            <ion-label color="medium">
              <span class="tw:text-xs">
                <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text>
              </span>
            </ion-label>
          </ion-item-divider>
          <ion-accordion [disabled]="true" value="{{ i }}">
            <ion-item slot="header" color="light">
              <ion-avatar slot="start">
                <ion-skeleton-text [animated]="true"></ion-skeleton-text>
              </ion-avatar>
              <ion-label color="dark">
                <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text><br />
              </ion-label>
            </ion-item>
          </ion-accordion>
        }
      </ion-accordion-group>
    </ion-list>
  }
</red-page-content>
